import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import apiClient from '@/lib/api';
import useAuthStore from '@/store/authStore';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { user, setUser, clearAuth } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);
  
  useEffect(() => {
    // If user data passed from AuthCallback, skip check
    if (location.state?.user) {
      setUser(location.state.user);
      setIsChecking(false);
      return;
    }
    
    const checkAuth = async () => {
      try {
        const response = await apiClient.get('/auth/me');
        setUser(response.data);
        setIsChecking(false);
      } catch (error) {
        clearAuth();
        setIsChecking(false);
      }
    };
    
    checkAuth();
  }, [location.state, setUser, clearAuth]);
  
  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-zinc-600 dark:text-zinc-400">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
};

export default ProtectedRoute;
